/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No1/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function No1({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/Relations/Content/Relation/ContactInfo/No"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let relationFromPersonRecordEmailsValueData = fromData.useDataFormat({ viewPath,
context: 'relation',
path: 'from_person_record.emails',
format: fromFormat.isEmptyList,
})
let relationFromPersonRecordPhonesValueData = fromData.useDataFormat({ viewPath,
context: 'relation',
path: 'from_person_record.phones',
format: fromFormat.isEmptyList,
})
let aggregateData = fromAggregate.and(relationFromPersonRecordEmailsValueData, relationFromPersonRecordPhonesValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}